import React, { useEffect } from "react";

// Animated checkmark (polished)
function AnimatedSuccess() {
  return (
    <div style={{ marginBottom: 20 }}>
      <svg width={56} height={56} viewBox="0 0 56 56" aria-hidden="true">
        <circle
          cx="28"
          cy="28"
          r="25"
          fill="none"
          stroke="#4BC970"
          strokeWidth="4"
          strokeDasharray="157"
          strokeDashoffset="0"
          style={{
            animation: "spinCircle 1.2s cubic-bezier(.7,0,0,1) forwards",
          }}
        />
        <polyline
          points="16,30 25,39 40,19"
          fill="none"
          stroke="#1F74EC"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            strokeDasharray: 36,
            strokeDashoffset: 36,
            animation: "drawCheck 0.8s ease forwards 0.7s",
          }}
        />
        <style>{`
          @keyframes spinCircle {
            0% { stroke-dashoffset: 157 }
            100% { stroke-dashoffset: 0 }
          }
          @keyframes drawCheck {
            100% { stroke-dashoffset: 0 }
            0% { stroke-dashoffset: 36 }
          }
        `}</style>
      </svg>
    </div>
  );
}

const PdfDownloadPage = ({ url, onBack }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok)
        throw new Error(
          "Network response was not ok. Status: " + response.status
        );

      const blob = await response.blob();
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = href;
      const filename = url.split("/").pop() || "download.pdf";
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    } catch (e) {
      alert(
        "Automatic download failed. The file will open in a new tab. Please use your browser's download option."
      );
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  // Auto-download when page loads
  useEffect(() => {
    handleDownload();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        background: "#21243b",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5vw 2vw",
        boxSizing: "border-box",
      }}
    >
      {/* Card container */}
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 2px 24px #0002",
          padding: "32px 18px 24px 18px",
          maxWidth: 370,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: 0,
        }}
      >
        <AnimatedSuccess />
        <div
          style={{
            fontWeight: 700,
            fontSize: "1.38rem",
            color: "#1F74EC",
            letterSpacing: "0.01em",
            marginBottom: 8,
            textAlign: "center",
          }}
        >
          Your PDF is ready!
        </div>
        <div
          style={{
            color: "#333",
            fontSize: "1rem",
            marginBottom: 24,
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          If it did not download automatically, click the Download button below.
        </div>

        {/* Download Button */}
        <button
          onClick={handleDownload}
          style={{
            background: "#f692ac",
            color: "#172447",
            border: "none",
            borderRadius: 8,
            padding: "12px 0",
            fontSize: "1.06rem",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
            boxShadow: "0 2px 8px 0 #0001",
            marginBottom: 10,
            letterSpacing: ".01em",
            transition: "background .2s",
          }}
          aria-label="Download PDF"
        >
          <span style={{ fontSize: 20, marginRight: 6 }}>⬇️</span>
          Download PDF
        </button>

        {/* Back button */}
        {onBack && (
          <button
            onClick={onBack}
            style={{
              background: "#e9eefa",
              color: "#1F74EC",
              border: "none",
              borderRadius: 8,
              padding: "10px 0",
              fontSize: ".97rem",
              cursor: "pointer",
              width: "100%",
              fontWeight: 500,
              marginTop: 4,
            }}
            aria-label="Back"
          >
            Back
          </button>
        )}
      </div>
    </div>
  );
};

export default PdfDownloadPage;

// import React from "react";

// // Animated checkmark (polished)
// function AnimatedSuccess() {
//   return (
//     <div style={{ marginBottom: 20 }}>
//       <svg width={56} height={56} viewBox="0 0 56 56" aria-hidden="true">
//         <circle
//           cx="28"
//           cy="28"
//           r="25"
//           fill="none"
//           stroke="#4BC970"
//           strokeWidth="4"
//           strokeDasharray="157"
//           strokeDashoffset="0"
//           style={{
//             animation: "spinCircle 1.2s cubic-bezier(.7,0,0,1) forwards",
//           }}
//         />
//         <polyline
//           points="16,30 25,39 40,19"
//           fill="none"
//           stroke="#1F74EC"
//           strokeWidth="4"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           style={{
//             strokeDasharray: 36,
//             strokeDashoffset: 36,
//             animation: "drawCheck 0.8s ease forwards 0.7s",
//           }}
//         />
//         <style>{`
//           @keyframes spinCircle {
//             0% { stroke-dashoffset: 157 }
//             100% { stroke-dashoffset: 0 }
//           }
//           @keyframes drawCheck {
//             100% { stroke-dashoffset: 0 }
//             0% { stroke-dashoffset: 36 }
//           }
//         `}</style>
//       </svg>
//     </div>
//   );
// }

// const PdfDownloadPage = ({ url, onBack }) => {
//   const handleDownload = async () => {
//     try {
//       // Fetch as blob; works with same-origin/CORS servers
//       const response = await fetch(url, { mode: "cors" });
//       if (!response.ok)
//         throw new Error(
//           "Network response was not ok. Status: " + response.status
//         );

//       const blob = await response.blob();
//       const href = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = href;

//       // Try to guess a good filename
//       const filename = url.split("/").pop() || "download.pdf";
//       link.download = filename;

//       // Append, click, revoke immediately for best mobile compatibility
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(href);
//     } catch (e) {
//       // Fallback: Warn user and try opening in a new tab
//       alert(
//         "Automatic download failed. The file will open in a new tab. Please use your device's 'Share' or 'Download' options."
//       );
//       window.open(url, "_blank", "noopener,noreferrer");
//     }
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         width: "100vw",
//         background: "#21243b",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "5vw 2vw",
//         boxSizing: "border-box",
//       }}
//     >
//       {/* Card container */}
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 16,
//           boxShadow: "0 2px 24px #0002",
//           padding: "32px 18px 24px 18px",
//           maxWidth: 370,
//           width: "100%",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           margin: 0,
//         }}
//       >
//         <AnimatedSuccess />
//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: "1.38rem",
//             color: "#1F74EC",
//             letterSpacing: "0.01em",
//             marginBottom: 8,
//             textAlign: "center",
//           }}
//         >
//           Your PDF is ready!
//         </div>
//         <div
//           style={{
//             color: "#333",
//             fontSize: "1rem",
//             marginBottom: 24,
//             textAlign: "center",
//             lineHeight: 1.5,
//           }}
//         >
//           Thank you.
//           <br /> Tap the button to download your PDF.
//         </div>

//         {/* Download Button */}
//         <button
//           onClick={handleDownload}
//           style={{
//             background: "#f692ac",
//             color: "#172447",
//             border: "none",
//             borderRadius: 8,
//             padding: "12px 0",
//             fontSize: "1.06rem",
//             fontWeight: 600,
//             cursor: "pointer",
//             width: "100%",
//             boxShadow: "0 2px 8px 0 #0001",
//             marginBottom: 10,
//             letterSpacing: ".01em",
//             transition: "background .2s",
//           }}
//           aria-label="Download PDF"
//         >
//           <span style={{ fontSize: 20, marginRight: 6 }}>⬇️</span>
//           Download PDF
//         </button>

//         {/* Back button, only show if onBack provided */}
//         {onBack && (
//           <button
//             onClick={onBack}
//             style={{
//               background: "#e9eefa",
//               color: "#1F74EC",
//               border: "none",
//               borderRadius: 8,
//               padding: "10px 0",
//               fontSize: ".97rem",
//               cursor: "pointer",
//               width: "100%",
//               fontWeight: 500,
//               marginTop: 4,
//             }}
//             aria-label="Back"
//           >
//             Back
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PdfDownloadPage;
